import { render } from "./StoreGiftRecord.vue?vue&type=template&id=4c631132&scoped=true"
import script from "./StoreGiftRecord.vue?vue&type=script&lang=js"
export * from "./StoreGiftRecord.vue?vue&type=script&lang=js"

import "./StoreGiftRecord.vue?vue&type=style&index=0&id=4c631132&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c631132"]])

export default __exports__